import React from 'react';
import PropTypes from 'prop-types';

import connect from 'app/libs/connect';
import S from 'app/features/landing/productComparison/components/Product/Icon.styled';
import {
  FAN_PACK_FREE_TRIAL_SKU,
  FAN_PACK_FREE_TRIAL_SKU_12,
  SUPER_FAN_PACK_FREE_TRIAL_SKU,
  PREMIUM_FREE_TRIAL_SKU,
} from 'app/constants/freeTrial';
import PremiumProductIcon from 'app/features/landing/productComparison/components/icons/PremiumProductIcon';
import FanProductIcon from 'app/features/landing/productComparison/components/icons/FanProductIcon';
import SuperFanProductIcon from 'app/features/landing/productComparison/components/icons/SuperFanProductIcon';
import { isFreeProduct } from 'app/features/products/selectors';

const UI = ({ isFree, sku }) => (
  <>
    {!isFree && (
      <S.Icon.Circle data-t="product-icon">
        {sku === PREMIUM_FREE_TRIAL_SKU && <PremiumProductIcon />}
        {sku === FAN_PACK_FREE_TRIAL_SKU && <FanProductIcon />}
        {sku === FAN_PACK_FREE_TRIAL_SKU_12 && <FanProductIcon />}
        {sku === SUPER_FAN_PACK_FREE_TRIAL_SKU && <SuperFanProductIcon />}
      </S.Icon.Circle>
    )}
  </>
);

UI.propTypes = {
  sku: PropTypes.string.isRequired,
  isFree: PropTypes.bool,
};

UI.defaultProps = {
  isFree: PropTypes.bool.false,
};

UI.displayName = 'Icon';

const state = { isFree: isFreeProduct };

const Icon = connect(state)(UI);

export { UI };

export default Icon;
